export default __webpack_public_path__ + "static/media/policy.1d66b53c.svg";